import { ToastsManager } from '@react_components/toasts';
import {
	ErrorManager,
	MessageType,
	defaultErrorObject,
} from '@react_components/errors';
import { DialogManager } from '@react_components/dialog';
import { store } from '../../../core/Store';
import { Routing } from '../../../core/Routing';
import { clearFullForm, Selectors } from '.';
import { gotoPage } from '../../../utils/gotoPage';
import SendOwuModal from '../../../views/sendOWUModal/SendOwuModal';
import { Provider } from 'react-redux';
import Button from '../../../components/button/Button';

export const pushGenericFailSave = () => {
	ErrorManager.pushError({
		...defaultErrorObject,
		title: 'Błąd zapisu',
		content:
			'Podczas próby zapisu formularza wystąpił błąd. Sprawdź i popraw wprowadzone dane lub skontaktuj się z obsługą.',
	});
};

export const pushPromptNext = () => {
	DialogManager.pushMsg({
		content:
			'Przed kontynuacją należy zaznaczyć wymagane zgody oraz podać adres e-mail do wysyłki kodu weryfikacyjnego',
		renderButtons: (closeFn) => (
			// a provider is necessary since modals are rendered outside of app root (thus not being inside main provider's context)
			<Provider store={store}>
				<SendOwuModal closeFn={closeFn} />
			</Provider>
		),
	});
};

export const pushCancelForm = () => {
	DialogManager.pushMsg({
		title: 'Czy chcesz wyczyścić formularz?',
		content: 'Wszystkie dane zostaną usunięte',
		renderButtons: (closeFn) => {
			return (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						padding: '10px',
					}}
				>
					<Button
						Icon={<></>}
						label="tylko cofnij"
						onClick={() => {
							gotoPage(Routing.main.start);
							closeFn();
						}}
						style={{
							fontSize: '12px',
							width: '40%',
							whiteSpace: 'nowrap',
							marginRight: '10px',
							borderColor: '#0372bb',
						}}
					/>
					<Button
						Icon={<></>}
						label="wyczyść"
						onClick={() => {
							clearFullForm();
							gotoPage(Routing.main.start);
							closeFn();
						}}
						style={{
							fontSize: '12px',
							borderColor: '#ff7171',
							width: '40%',
							marginLeft: '10px',
							color: '#ff7171',
						}}
					/>
				</div>
			);
		},
	});
};

export const pushResendCode = () => {
	const state = store.getState();
	const email = Selectors.getPersonalInfo(state).email;

	if (!email) {
		ErrorManager.pushError({
			canClose: true,
			content:
				'Do wysyłki kodu weryfikacyjnego potrzebny jest adres e-mail',
			title: 'Błąd wysyłki',
			type: MessageType.warning,
		});
		return;
	}

	ToastsManager.pushToast({
		alertProps: {},
		content: 'Kod został wysłany ponownie',
		autoHideDuration: 5000,
	});
};

export const pushFormErrors = (errors?: string[]) => {
	ErrorManager.pushError({
		canClose: true,
		title: 'Błąd zapisu',
		content: (
			<span>
				Formularz nie został uzupełniony poprawnie.
				<br />
				Popraw zaznaczone błędy.
				<br />
				{errors?.map((err, idx) => (
					<p
						style={{
							background: '#ffd5d5',
							margin: 0,
							padding: '4px',
							borderRadius: '4px',
							marginTop: '4px',
						}}
						key={err + idx}
					>
						{err}
					</p>
				))}
			</span>
		),
		type: MessageType.warning,
	});
};
